import { JetView } from 'webix-jet'; // Import JetView class from webix-jet to define custom views
import { devConfig } from 'config/config'; // Import global configuration file

/**
 * Class representing the table view for loyalty level change history.
 * @extends JetView
 */
export default class tableLoyaltyLevelChangeHistoryView extends JetView {
    /**
     * Builds and returns the UI configuration for this view.
     * @returns {Object} The Webix UI configuration object.
     */
    config() {
        const _ = this.app.getService('locale')._; // Access localization service for translations
        var url = devConfig.geturlApi() + 'Report/LoyaltyLevelChangeHistory'; // Define the API endpoint used to load table data
        var filter; // Variable used to store filter parameters sent from another view or popup

        // Listen for a global event that provides filter parameters for the table
        this.on(this.app, 'filter:table', (data) => {
            filter = data; // Save the filter data received from the event
        });

        // Return the UI layout configuration
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide', // Define wide layout type
                            view: 'datatable', // Create a Webix datatable component
                            id: 'datatable', // Unique ID to reference this datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // Apply consistent Webix styling
                            select: true, // Allow row selection by the user
                            columns: [
                                // ------------------------------
                                // Table Columns Definition
                                // ------------------------------
                                {
                                    id: 'UserId', // Unique data key for each row
                                    header: _('ID Usuario'), // Column label (localized)
                                    width: 120, // Column width in pixels
                                    sort: 'int', // Enable numeric sorting
                                },
                                {
                                    id: 'BeforeLevel',
                                    header: _('Nivel anterior'),
                                    width: 140,
                                    sort: 'int',
                                },
                                {
                                    id: 'CurrentLevel',
                                    header: _('Nivel actual'),
                                    width: 140,
                                    sort: 'int',
                                },
                                {
                                    id: 'ChangeDate',
                                    header: _('Fecha de cambio'),
                                    width: 180,
                                    sort: 'date', // Enable date sorting
                                },
                                {
                                    id: 'PointsChange',
                                    header: _('Puntos al cambio'),
                                    width: 160,
                                    sort: 'int',
                                },
                                {
                                    id: 'ReasonChange',
                                    header: _('Motivo del cambio'),
                                    width: 180,
                                    sort: 'string',
                                },
                                {
                                    id: 'EvaluationPeriod',
                                    header: _('Periodo evaluado'),
                                    width: 200,
                                    sort: 'string',
                                },
                                {
                                    id: 'EventId',
                                    header: _('ID Evento'),
                                    width: 120,
                                    sort: 'int',
                                },
                            ],
                            // ------------------------------
                            // Event handlers for datatable
                            // ------------------------------
                            on: {
                                // Triggered before data is loaded into the table
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Display loading overlay while data loads
                                },
                                // Triggered after data finishes loading
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Remove loading overlay once data is displayed
                                },
                            },
                            // ------------------------------
                            // Ready event: executed once table is rendered
                            // ------------------------------
                            ready: function () {
                                // If table has no rows, display “No data” overlay
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Add overlay behavior to this datatable
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                        _('No hay datos') +
                                        '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltip display on hover
                            math: true, // Enable math calculations (if needed)
                            loadahead: devConfig.getDefaultDataFetch(), // Define how many rows to prefetch
                            pager: 'pagerA', // Link to external pager component by ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Called when the view is initialized (attached to DOM).
     * Sets up logic for filtering and reloading the table.
     * @param {Object} grid - The datatable component instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Access localization service for translations
        grid = $$('datatable'); // Retrieve the datatable instance by its ID
        var url = devConfig.geturlApi() + 'Report/LoyaltyLevelChangeHistory'; // Define API endpoint for table data

        // Listen for the event "report:filter" to apply filters dynamically
        this.on(this.app, 'report:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter object to key-value pairs
            var string1 = ''; // Build query string dynamically based on filters

            // Loop through all filter parameters
            for (var i = 0; i < object.length; i++) {
                // Handle simple (non-object) filters
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filter input (Datepicker)
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split start and end date
                        string1 = string1 + '&dateFrom=' + date[0]; // Append start date to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Append end date to query string
                    } else {
                        // Append normal key=value filters
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle complex filters containing nested date ranges
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Get nested key-value pairs
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Handle "start" date in range
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create JS Date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                                } else {
                                    // Handle "end" date in range
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Clear all current rows from datatable before loading new data
            grid.clearAll();

            // Reload datatable with new query parameters applied
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);

            // Emit event to update filter state across components
            this.app.callEvent('filter:table', [string1]);

            // Close the filter popup once filtering is applied
            $$('filterPopup').hide();
        });
    }
}

// FILE DOCUMENTED
